import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { DeleteSubObjectives } from "../../../Redux/Reducers/ReportStage/SubObjectives";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import loadConfig from "../../../Services/Api/ApiServices";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import AddEditSubObjective from "../SubObjectives/AddEditSubObjective";
import { useLocation, useParams } from "react-router-dom";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import TransferRequestDetailsForm from "./TransferRequestDetailsForm";
const JustificationsforTransfer = (props) => {
  const { reportId, projectModificationRequestsId } = useParams();

  const [jsonData, setJsonData] = useState({});
  const dispatch = useDispatch();
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [subObjectivesId, setsubObjectivesId] = useState(null);
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );
  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const location = useLocation();
  const url = location.pathname;

  const isExtension = url.includes("ProjectExtensionRequestDetails");
  const isTransfer = url.includes("TransferRequestDetails");
  const RequestAccessor = [
    {
      KeyName: "justificationsforTransferBeneficiary",
      ShowStatus: true,
      NmaeColumn: isExtension
        ? "مبررات التمديد (المستفيد)"
        : isTransfer
        ? "مبررات المناقلة (المستفيد)"
        : "",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "justificationsForTransferEmployee",
      ShowStatus: true,
      NmaeColumn: isExtension
        ? "مبررات التمديد (الموظف)"
        : isTransfer
        ? "مبررات المناقلة (الموظف)"
        : "",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        setsubObjectivesId(e.target.value);
        console.log(e.target.value, "sssssssssssss");

        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: "",

      id: "editBtn",
      title: "عرض",
      ShowStatus: !props.disabled,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        {
          <TransferRequestDetailsForm
            projectModificationRequestsId={projectModificationRequestsId}
            reportId={reportId}
          />
        }
      </div>
    ),
    title: "الاهداف الفرعية",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <TransferRequestDetailsForm
          reportId={reportId}
          projectModificationRequestsId={projectModificationRequestsId}
          subObjectivesId={subObjectivesId}
          canEdit="edit"
        />
      </div>
    ),
    title: "الاهداف الفرعية",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  return (
    <>
      <>
        <TableAHSF
          culomEdite={culomEdite}
          uniqueValue={"subObjectivesId"}
          valueButtonAction={"subObjectivesId"}
          URL={`api/JustificationsforTransfer/GetListJustificationsforTransfer`}
          UrlBody={{
            projectModificationRequestsId: projectModificationRequestsId,
          }}
          staticKeyEdite={staticKeyEdite}
          accessor={RequestAccessor}
          titelTable={""}
          selectRowNumber={true}
          checkBoksColumName="اختيار"
          sort={true}
          pagination={true}
          AppStatus={true}
          // tableBtn={!shouldDisableFields}
          tableBtn={false}
          sortTable={true}
          keyNameSort={"dateCreate"}
          dateKey="dateCreate"
          dateformat="DD/MM/YYYY h:mm a"
          arrayNameSort={["applicationNumber"]}
          search={true}
          openPopupState={false}
          DropdownArrayFiltration={[]}
          DropdownFiltration={false}
          exportData={true}
          checkBoks={false}
          nameColumAction=""
          total={false}
          arrayButton={M_ApplicationsBtns}
          ArrayNameDataColum={[]}
          columnKeyNameArray={[
            { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
          ]}
          PopupOPjectData={PopupOPjectData}
          popUpTitle={"معلومات الطلب"}
          popUpBody={
            <PopupAHSF
              isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
              isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
              title={popUpBodyOPjectData.title}
              componentBody={popUpBodyOPjectData.componentBody}
              maxWidth={popUpBodyOPjectData.maxWidth}
              maxHeight={popUpBodyOPjectData.maxHeight}
            />
          }
        />
      </>
      ,
    </>
  );
};
export default JustificationsforTransfer;
